import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeSecond';
const args = {};

export class ModeSecond extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
